import { humanize } from '../format';
import React from 'react';

export function formatTrailingZeros(value) {
  return value.replace(/(\.[0-9]*[1-9])0+$|\.0*$/, '$1');
}

export function formatMoney(sum) {
  return (
    <span className={'nowrap'}>
      {humanize(sum || 0)} <span className="icon-rouble rouble" />
    </span>
  );
}
